//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import('./indexAppl');
const edit = () => import('./edit.vue');

export default {
  routes: [
    {
      path: '/clusters/v2024/indexAppl',
      name: 'clusters_v2024_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/clusters/v2024/indexAdmin',
      name: 'clusters_v2024_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/clusters/v2024/edit',
      name: 'clusters_v2024_edit',
      component: edit,
      meta: {public: true}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/clusters/v2024/router.js